<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert type="error" v-show="erro">{{ mensagemErro }}</v-alert>

    <v-alert
      v-show="newNotify.isNewNotify"
      border="left"
      close-text="Close Alert"
      color="green accent-4"
      dark
      @click="closeNotify"
    >
      {{ newNotify.text }}
    </v-alert>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Blacklists'"
      :tableHeader="headers"
      :tableRows="listEnderecos"
      :isEdit="true"
      :isFinish="false"
      :isDel="false"
      :isPrint="false"
      v-on:datatable-updaterow="viewItensOnBlacklist"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <FormModal
      :isTheModalOpen="formModalData.isOpen"
      :modalButtonText="formModalData.buttonText"
      :modalFormTitle="formModalData.formTitle"
      :modalType="formModalData.modalType"
      :isLoadingRequestDisable="formModalData.isLoadingRequestDisable"
      :isModalButtonVisible="formModalData.isButtonsVisible"
      :isModalButtonDisabled="formModalData.isButtonsDisabled"
      v-on:formmodal-close="formModalData.isOpen = false"
      v-on:formmodal-action="insert"
    >
      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.nomeEndereco"
          name="nomeEndereco"
          label="Nome da Unidade"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.nomeResponsavel"
          name="nomeResponsavel"
          label="Responsável pela Unidade"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          label="Lista de Produtos"
          :items="listOfItens"
          v-model="itemSelecionado"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <DataTable
          v-show="showSkeletonTableModal == false"
          :tableTitle="'Blacklists'"
          :tableHeader="headersItens"
          :tableRows="itensNaBlackList"
          :isEdit="false"
          :isFinish="false"
          :isDel="true"
          :isPrint="false"
          v-on:datatable-updaterow="viewItensOnBlacklist"
          v-on:datatable-deleterow="deleteItemFromList"
        ></DataTable>

        <SkeletonTable
          v-show="showSkeletonTableModal == true"
          :showSkeletonTable="showSkeletonTable"
        ></SkeletonTable>
      </v-col>
      
    </FormModal>
  </v-col>
</template>

<script>
import DataTable from "@/components/DataTable2.vue";
import Loading from "../components/Loading.vue";
import FormModal from "@/components/FormModal.vue";
import axios from "../plugins/axios";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";

export default {
  components: {
    DataTable,
    Loading,
    FormModal,
    SkeletonTable,
  },

  data: () => ({
    newNotify: {
      isNewNotify: false,
      text: "",
    },

    erro: false,
    mensagemErro: "Erro",
    showSkeletonTable: true,
    loading: false,
    showSkeletonTableModal: true,

    headers: [
      {
        text: "ID",
        value: "numeroEnderecoOrdemServico",
      },
      {
        text: "Unidade",
        value: "nomeEndereco",
      },
      {
        text: "Responsável pela Unidade",
        value: "nomeResponsavel",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "value",
      },
      {
        text: "Nome Produto",
        value: "text",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    formModalData: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroEndereco: null,
        nomeEndereco: null,
        nomeResponsavel: null,
        itensNaBlackList: [],
        descricaoTela: "blacklist",
      },
    },

    listEnderecos: [],
    listOfItens: [],
    itensNaBlackList: [],
    itemSelecionado: null,
  }),

  created() {
    this.initialize();
  },

  watch: {
    itemSelecionado() {
      if (this.itemSelecionado) {
        const itemInsert = this.listOfItens.filter((item) => item.value == this.itemSelecionado);

        this.itensNaBlackList.unshift(itemInsert[0]);
        this.itemSelecionado = "";
      }
    }
  },

  methods: {
    async initialize() {
      try {
        this.returnAllEnderecos();
        this.recoverListOfItens();
      } catch (error) {
        console.log(error);
      }
    },

    async returnAllEnderecos() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      };

      let enderecos = await axios.get("enderecoordemservicoblacklist", config);
      this.showSkeletonTable = false;
      this.listEnderecos = enderecos.data;
    },

    async recoverListOfItens() {
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": store.state.token,
          },
        };

        const responseItens = await axios.get("item", config);

        this.listOfItens = responseItens.data.map((row) => {
          return { value: row.numeroItemSistema, text: row.nomeItem };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async insert() {
      var config = {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      };

      this.formModalData.actualEdit.itensNaBlackList = this.itensNaBlackList;

      this.formModalData.isLoadingRequestDisable = true;
      await axios.post("blacklist", this.formModalData.actualEdit, config);
    
      this.formModalData.isOpen = false;
      this.formModalData.isLoadingRequestDisable = false;
      this.initialize();
    },

    viewItensOnBlacklist(value) {
      this.loading = true
      this.showSkeletonTableModal = true
      this.formModalData.isOpen = true;
      this.formModalData.isEdit = true;
      this.formModalData.buttonText = "Concluir";
      this.formModalData.formTitle = "Blacklists";

      this.formModalData.actualEdit.numeroEndereco = value.numeroEnderecoOrdemServico;
      this.formModalData.actualEdit.nomeEndereco = value.nomeEndereco;
      this.formModalData.actualEdit.nomeResponsavel = value.nomeResponsavel;
      this.itensNaBlackList = value.blacklist
      
      this.showSkeletonTableModal = false
      this.itemSelecionado = null;
      this.loading = false
    },

    deleteItemFromList(item) {
      this.itensNaBlackList = this.itensNaBlackList.filter((itemSelecionado) => itemSelecionado.value != item.value);
    },

    closeNotify() {
      this.newNotify.isNewNotify = false;
    },
  },
};
</script>